import { dmApi } from "../dmApi";
import { getAuthorizationHeader, handleQueryErrorAndSuccess } from "../../helpers/RtkQueryUtils";

export const reviewLinkApi = dmApi.injectEndpoints({
  endpoints: (build) => ({

    // ✅ Add Review Link (POST)
    addReviewLink: build.mutation({
      query: (formData) => ({
        url: "/admin/add-review-link",
        method: "POST",
        body: formData,
        headers: getAuthorizationHeader(), // Includes token, etc.
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryErrorAndSuccess(queryFulfilled, "Review link added");
      },
      invalidatesTags: ["ReviewLinks"],
    }),

    // ✅ Get All Review Links (GET)
    getAllReviewLinks: build.query({
      query: ({ page = 1, limit = 10 }) => ({
        url: `/admin/get-all-reviews-link?page=${page}&limit=${limit}`,
        method: "GET",
        headers: getAuthorizationHeader(),
      }),
      providesTags: ["ReviewLinks"],
    }),
  
    // ✅ Get Single Review by ID (GET)
    getReviewById: build.query({
      query: (reviewLinkId) => ({
        url: `/admin/get-review-by-id-link?reviewId=${reviewLinkId}`,
        method: "GET",
        headers: getAuthorizationHeader(),
      }),
      providesTags: (result, error, id) => [{ type: "ReviewLinks", id }],
    }),

    // ✅ Update Review Link (PUT)
    updateReviewLink: build.mutation({
      query: ({ reviewLinkId, formData }) => ({
        url: `/admin/update-review-link?reviewId=${reviewLinkId}`,
        method: "PUT",
        body: formData,
        headers: getAuthorizationHeader(),
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryErrorAndSuccess(queryFulfilled, '', "Review link updated");
      },
      invalidatesTags: ["ReviewLinks"],
    }),

    // ✅ Delete Review Link (DELETE)
    deleteReviewLink: build.mutation({
      query: (reviewId) => ({
        url: `/admin/delete-review-link?reviewId=${reviewId}`,
        method: "DELETE",
        headers: getAuthorizationHeader(),
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryErrorAndSuccess(queryFulfilled, '', "Review link deleted");
      },
      invalidatesTags: ["ReviewLinks"],
    }),
    getReferralContent: build.query({
  query: () => ({
    url: '/admin/get-referral-content',
    method: 'GET',
    headers: getAuthorizationHeader(),
  }),
  providesTags: ['ReferralContent'],
}),

addReferralContent: build.mutation({
  query: (body) => ({
    url: '/admin/add-referral-content',
    method: 'POST',
    body,
    headers: getAuthorizationHeader(),
  }),
  async onQueryStarted(_, { queryFulfilled }) {
    await handleQueryErrorAndSuccess(queryFulfilled, '', 'Referral content submitted');
  },
  invalidatesTags: ['ReferralContent'],
}),
    
  }),
});

export const {
  useAddReviewLinkMutation,
  useGetAllReviewLinksQuery,
  useGetReviewByIdQuery,
  useUpdateReviewLinkMutation,
  useDeleteReviewLinkMutation,
  useGetReferralContentQuery,
  useAddReferralContentMutation
} = reviewLinkApi;
